import { render, staticRenderFns } from "./GeneralMessage.vue?vue&type=template&id=2f6e813b&scoped=true&"
import script from "./GeneralMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralMessage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMessage.vue?vue&type=style&index=0&id=2f6e813b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e813b",
  null
  
)

export default component.exports